<template>
    <AutocompleteControl v-bind="props" v-model="value" :error-message></AutocompleteControl>
</template>

<script lang="ts" setup generic="Item">
import { useField } from 'vee-validate'
import AutocompleteControl from './AutocompleteControl.vue'
import type { CommonProps } from './types'
import { toRef } from 'vue'

interface Props {
    items: Item[]
    itemText: keyof Item & string
    itemValue: keyof Item & string
    name: string
}

const props = defineProps<CommonProps & Props>()

const { errorMessage, value } = useField<string | (Array<string> & string)>(toRef(props, 'name'))
</script>

<style scoped></style>
